/* global axios */
import ApiClient from './ApiClient';

class PlatformAnnouncementsAPI extends ApiClient {
  constructor() {
    super('platform_announcements', { accountScoped: false });
  }

  acknowledge(id) {
    return axios.post(`${this.url}/${id}/acknowledge`);
  }
}

export default new PlatformAnnouncementsAPI();
